const TOKEN_REFUSED_STATUSES = [401, 404];

const isTokenRefused = (response: Response | null): boolean =>
  Boolean(response && TOKEN_REFUSED_STATUSES.includes(response.status));

export default isTokenRefused;
